import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import WarningCircle from '../assets/img/warning-circle.svg';
import { segmentEvent } from '../helpers/sendEvent';

// General error page for the in-store VCC flow. There is no retailer cancel URL or Shopify
// transaction here, so the only way out is to restart the flow from the landing page.
//
// A screen that knows exactly what went wrong can say so: navigate here with
// history.push('/error', { message }) and that message replaces the generic copy.
function InstoreVccError({ storeId }) {
  const location = useLocation();
  const message = typeof location.state?.message === 'string' ? location.state.message.trim() : '';

  useEffect(() => {
    segmentEvent('page', 'Instore General Error', { error_message: message || null });
  }, []);

  const tryAgain = () => {
    segmentEvent('page', 'Instore Error Try Again Clicked', { error_message: message || null });
    const params = storeId ? `?flow=instore_vcc&store_id=${encodeURIComponent(storeId)}` : '';
    window.location.href = `/${params}`;
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <div className="k-error-image-wrapper">
          <img width="150px" height="150px" className="error-icon" src={WarningCircle} alt="" />
        </div>
        <h1 className="congratulation-header">Something went wrong</h1>
        {message ? (
          <p className="k-not-approved-text">{message}</p>
        ) : (
          <>
            <p className="k-not-approved-text">We couldn&apos;t complete your request.</p>
            <p className="k-not-approved-text">Please try again.</p>
          </>
        )}
        <div className="k-submit k-error-button k-not-approved-button">
          <button type="button" onClick={tryAgain}>
            <strong>Try again</strong>
          </button>
        </div>
      </section>
    </div>
  );
}

export default InstoreVccError;
